export default {
  // Options.jsx
  items_per_page: '/ сторінці',
  label_items_per_page: 'Items / page',
  jump_to: 'Перейти',
  jump_to_confirm: 'підтвердити',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Попередня сторінка',
  next_page: 'Наступна сторінка',
  prev_5: 'Попередні 5 сторінок',
  next_5: 'Наступні 5 сторінок',
  prev_3: 'Попередні 3 сторінки',
  next_3: 'Наступні 3 сторінки',
};
